module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.cb81706e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.png
// module id = 3114
// module chunks = 11